import React from 'react';
import PropTypes from 'prop-types';
import FeatureWrapper from '../../Components/FeatureWrapper';
import OldMassives from './OLD';
import NewMassives from './NEW';

const MassiveMessages = function MassiveMessages({
  handleChangeSection,
  userRoles = [],
}) {
  return (
    <FeatureWrapper
      featureName="MASSIVE_FEATURES"
      childReplacement={
        <OldMassives
          handleChangeSection={handleChangeSection}
          userRoles={userRoles}
        />
      }
    >
      <NewMassives
        handleChangeSection={handleChangeSection}
        userRoles={userRoles}
      />
    </FeatureWrapper>
  );
};

MassiveMessages.propTypes = {
  handleChangeSection: PropTypes.func.isRequired,
  userRoles: PropTypes.array,
};

export default MassiveMessages;
